import { TableTitle, TableHead as UITableHead } from '@genial/components';
import React from 'react';

import { tableHeadAlignments } from '../../../../../../constants';

interface TableHeadProps {
  viewportType: 'tablet' | 'desktop';
  tableHead: { [key: string]: { desktop: string; tablet: string } };
  widthCols: { [key: string]: { desktop: number; tablet: number } };
}

export const TableHead: React.FC<TableHeadProps> = ({ viewportType, tableHead, widthCols }) => {
  const items = Object.entries(tableHead);

  const Content = items.map((item, index) => (
    <TableTitle
      key={item[0]}
      testID={`table-head-title-${index}`}
      width={widthCols[item[0]][viewportType]}
      textAlign={tableHeadAlignments[item[0]]}>
      {item[1][viewportType] as string}
    </TableTitle>
  ));

  return (
    <UITableHead display={'flex'} testID="table-pension-statements-head">
      {Content}
    </UITableHead>
  );
};
